<!-- Notifications global (Toats) -->
<p-toast></p-toast>
<!-- ---------------------------- -->
<router-outlet></router-outlet>
